import Btari1 from '../../../media/fasad/Btari.webp'
import Btari2 from '../../../media/fasad/Btari.webp'


const Btariimages =[
Btari1,Btari2
]

export default Btariimages;